import { useSelector } from 'react-redux';
import {
  CartParent,
  DeliveryAddressParent,
  StoreHomePage,
  MlExclusivePage,
  ListingFilterSubcategoryParent,
  ProductDescriptionDataParent,
  ProductListingParent,
  SortAndFiltersParent,
  CategoryDescription,
} from '../types';
import Store from '../types/store';

const useParkplusStoreV2 = () => {
  const parkplusStoreV2 = useSelector((state) => state?.parkplusStoreV2) || {};

  const {
    storeHomepage,
    mlExclusivepage,
    cart,
    listing,
    deliveryAddress,
    listingFilterSubcategory,
    sortAndFilters,
    productDescriptions,
    categoryListing,
    categoryDescription,
  } = parkplusStoreV2 || {};


  const {
    apiStatus: categoryListingApiStatus,
    data: categoryListingData,
  } :StoreHomePage  = categoryListing;

  const {
    apiStatus: categoryDescriptionApiStatus,
    data: categoryDescriptionData,
    categoryName : categoryDescriptionName
  } :CategoryDescription = categoryDescription;

  const {
    apiStatus: storeHomepageApiStatus,
    data: storeHomepageData,
  }: StoreHomePage = storeHomepage;

  const {
    apiStatus: mlExclusivepageApiStatus,
    data: mlExclusivepageData,
  }: StoreHomePage = mlExclusivepage;

  const { data: cartData, apiStatus: cartApiStatus }: CartParent = cart;

  const {
    apiStatus: productDescriptionDataApiStatus,
    data: productDescriptionData,
  }: ProductDescriptionDataParent = productDescriptions;

  const {
    data: listingData,
    apiStatus: listingApiStatus,
  }: ProductListingParent = listing;

  const {
    data: deliveryAddressData,
    apiStatus: deliveryAddressApiStatus,
  }: DeliveryAddressParent = deliveryAddress;

  const {
    data: listingFilterSubcategoryData,
    apiStatus: listingFilterSubcategoryApiStatus,
  }: ListingFilterSubcategoryParent = listingFilterSubcategory;

  const {
    data: sortAndFiltersData,
    apiStatus: sortAndFiltersApiStatus,
  }: SortAndFiltersParent = sortAndFilters;

  return {
    categoryListing,
    categoryListingApiStatus,
    categoryListingData,
    categoryDescription,
    categoryDescriptionApiStatus,
    categoryDescriptionData,
    categoryDescriptionName,
    storeHomepage,
    storeHomepageApiStatus,
    storeHomepageData,
    mlExclusivepage,
    mlExclusivepageApiStatus,
    mlExclusivepageData,
    cart,
    cartData,
    cartApiStatus,
    listing,
    listingData,
    listingApiStatus,
    deliveryAddressData,
    deliveryAddressApiStatus,
    listingFilterSubcategory,
    listingFilterSubcategoryData,
    listingFilterSubcategoryApiStatus,
    sortAndFilters,
    sortAndFiltersData,
    sortAndFiltersApiStatus,
    productDescriptions,
    productDescriptionData,
    productDescriptionDataApiStatus,
  };
};

export default useParkplusStoreV2;
